import {
  CUSTOMER_STATUS_ACTIVE,
  CUSTOMER_STATUS_INACTIVE,
} from "../constants/CustomerStatus";
import { QUICK_FILTER_TEST } from "../constants/QuickFilters";

import type { CustomerFiltersType } from "../models/CustomerFilter";

export function prepareCustomerFilters({
  quickFilters = [],
  ...filters
}: Partial<CustomerFiltersType> = {}) {
  const statusFilters = quickFilters.filter(
    (filter) =>
      filter === CUSTOMER_STATUS_ACTIVE || filter === CUSTOMER_STATUS_INACTIVE
  );

  const hasSingleStatusFilter = statusFilters.length === 1;
  const isTestFilterSelected = quickFilters.includes(QUICK_FILTER_TEST);

  return {
    ...filters,
    ...(hasSingleStatusFilter && {
      active: statusFilters.includes(CUSTOMER_STATUS_ACTIVE),
    }),
    ...(isTestFilterSelected && { test: true }),
  };
}
